// extracted by mini-css-extract-plugin
export default {"tryAgain":"N_cZ","result":"N_c0"};